<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.billingPhone' | translate }}
  </label>
  <input type="text" class="form-control" id="billingPhone" formControlName="billingPhone"  [ngClass]="{ 'is-invalid': campaignForm.get('billingPhone')?.invalid}" />
  <input type="checkbox" class="form-check-input" formControlName="billingPhoneChecked" (change)="checkboxClicked()" id="billingPhoneChecked"> <label class="form-check-label" for="billingPhoneChecked">{{'campaign.billingPhoneChecked' | translate}}</label>
  <div [ngClass]="{ 'invalid-feedback': campaignForm.get('billingPhone')?.invalid}" class="form-text">
    <div *ngFor="let err of campaignForm.get('billingPhone')?.errors | keyvalue">
      {{ 'validation.' + err.key | translate }}
    </div>
  </div>
</div>
